import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  Events,
  ActionSheetController,
  AlertController,
  LoadingController
} from "ionic-angular";
import { EventsProvider } from "../../providers/events/events.provider";
import { UserProvider } from "../../providers/user/user.provider";
import { ChatPage } from "../chat/chat";
import { AuthProvider } from "../../providers/auth/auth.provider";
import { LoginModalPage } from "../login-modal/login-modal";
import { EventUsersPage } from "../event-users/event-users";
import { ReportsProvider } from "../../providers/reports/reports";
import { UserPage } from "../user/user";

/**
 * Generated class for the EventPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-event",
  templateUrl: "event.html"
})
export class EventPage {
  event: any;
  hasJoined = false;
  author: any;
  currentUser: any;
  want_to_join_event = true;
  cardSelectorModal: any;
  avatars = [];
  loader: any;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private eventsProvider: EventsProvider,
    private reportProvider: ReportsProvider,
    private actionSheetCtrl: ActionSheetController,
  
    public loadingCtrl: LoadingController,
    private events: Events,
    private alertCtrl: AlertController,
    private authProvider: AuthProvider,
    private userProvider: UserProvider
  ) {
    this.cardSelectorModal = this.modalCtrl.create(LoginModalPage, {});
    this.event = this.navParams.get("event");
    console.log("navparams event", this.event);

    this.events.subscribe("user:login", () => {
      this.cardSelectorModal.dismiss();
      if (this.want_to_join_event) {
        setTimeout(async () => {
          this.currentUser = await this.userProvider.getUser();
          await this.joinEvent();
        }, 1000);
      }
    });
    this.events.subscribe("user:logout", () => {});
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad EventPage");
    this.refresh();
  }


  goToUser(user){
    console.log("goToUser", user);
    this.navCtrl.push(UserPage, {user : user})
  }

  async refresh() {
    this.event = await this.eventsProvider.getEventById(this.event.id);
    // console.log("this.event",this.event);
    this.author = await this.userProvider.getUser(this.event.created_by);
    // console.log("this.author",this.author);
    this.currentUser = await this.userProvider.getUser();
    // console.log("this.currentUser",this.currentUser);
    if (
      this.currentUser &&
      this.event.users &&
      this.event.users.indexOf(this.currentUser.uid) != -1
    )
      this.hasJoined = true;
    this.avatars = await this.loadAvatars();
  }

  async joinEvent() {
    if (this.authProvider.isConnected()) {
      console.log("joinEvent A");
      let event = this.event;
      await this.eventsProvider.addUserToEvent(event.id, this.currentUser.uid);
      await this.userProvider.incrementEventParticipate(this.currentUser);
      this.refresh();
    } else {
      console.log("joinEvent B");
      // console.log('checkLogin offline');
      this.want_to_join_event = true;
      this.cardSelectorModal.onDidDismiss(data => {
        // console.log("data",data);
        this.refresh();
        if (data != null) {
        }
      });
      this.cardSelectorModal.present();
    }
  }

  async loadAvatars() {
    // console.log("loadAvatars",this.event["users"])
    let avatars = [];
    let user_data;
    for (let user of this.event["users"]) {
      user_data = await this.userProvider.getUser(user);
      avatars.push(user_data);
    }
    // console.log("avatars",avatars);
    return avatars;
  }
  goToChat() {
    this.navCtrl.push(ChatPage, { event: this.event });
  }
  goToEventUsers() {
    console.log("goToEventUsers", this.event.users)
    this.navCtrl.push(EventUsersPage, { users: this.event.users });
  }

  async deleteEvent(){
    this.presentLoading("Suppression de l'événement...");
    await this.eventsProvider.deleteEvent(this.event.id);
    setTimeout(() => {
      this.hideLoading();
      this.navCtrl.pop()
    }, 1000);
  }

  hideLoading() {
    this.loader.dismiss();
  }

  presentLoading(message) {
    this.loader = this.loadingCtrl.create({
      content: message
    });
    this.loader.present();
  }

  presentAlert(title,message){

    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            console.log('Agree clicked');
          }
        }
      ]
    });
    confirm.present();
  }



  sendReport(){
    this.presentLoading("Envoi du signalement ...");
    this.reportProvider.sendRepport(this.currentUser.uid, 'user', this.event);
    setTimeout(() => {
      this.loader.dismiss();
    },1000);
  }

  async unjoinEvent(){
    let event = this.event;
    await this.eventsProvider.removeUserToEvent(event.id, this.currentUser.uid);
    await this.userProvider.decrementEventParticipate(this.currentUser);
    this.hasJoined = false;
    this.refresh();

  }
  presentActionSheet() {

    let buttons = [];


    if(this.event.created_by == this.currentUser.uid){
      buttons.push({
        text: "Supprimer mon évenement",
        role: "destructive",
        handler: () => {
          console.log("Destructive clicked");
          this.deleteEvent();
        }
      });
    }
    else {
      buttons.push({
        text: "Signaler l'évenement",
        role: "destructive",
        handler: () => {
          console.log("Destructive clicked");
          this.sendReport();
        }
      });

      if(this.hasJoined)
        buttons.push({
          text: "Ne plus participer",
          handler: () => {
            console.log("Archive clicked");
            this.unjoinEvent();
          }
        });
    }

    

    buttons.push({
      text: "Annuler",
      role: "cancel",
      handler: () => {
        console.log("Cancel clicked");
      }
    });

    let actionSheet = this.actionSheetCtrl.create({
      title: 'Options',
      buttons: buttons
    });

    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/event.ts